import React, { FC } from "react";
import Image from "next/image";
import Link from "next/link";

import { ProjectType } from "@/lib/types";

const ProjectItem: FC<ProjectType> = ({
  excerpt,
  featuredImage,
  slug,
  title,
}) => {
  return (
    <div className="bg-secondary-light dark:bg-secondary-dark border-1 border-secondary-light dark:border-secondary-dark rounded-xl shadow-lg hover:scale-105 transition-all ease-out duration-150 cursor-pointer mb-10 sm:mb-0 ">
      <Link href={`/projects/${slug}`}>
        <div className="w-full h-64 relative">
          <Image
            className="rounded-t-xl border-none"
            src={featuredImage}
            alt={title}
            layout="fill"
            objectFit="cover"
          />
        </div>
        <div className="text-center px-4 py-6">
          <p className="font-general-medium text-lg md:text-xl mb-2">{title}</p>
          <span
            className="text-md text-justify"
            dangerouslySetInnerHTML={{ __html: excerpt }}
          />
        </div>
      </Link>
    </div>
  );
};

export default ProjectItem;
